// Core
import React from 'react'
// Library
import clsx from 'clsx'
// Styles
import styles from 'components/Onboarding/CurrencyToggle/CurrencyToggle.module.scss'
// constants
import {CURRENCIES, ICurrency} from 'constants/currencies'

interface CurrencyToggleProps {
  value: ICurrency
  onChange: (currency: ICurrency) => void
}

const CurrencyToggle: React.FC<CurrencyToggleProps> = ({ value, onChange }) => {
  return (
    <div className={styles.currencyToggle}>
      {Object.values(CURRENCIES).map((currency) => (
        <button
          key={currency.code}
          className={clsx(styles.currencyBtn, {
            [styles.active]: value.code === currency.code,
          })}
          onClick={() => onChange(currency)}>
          {currency.code}
        </button>
      ))}
    </div>
  )
}

export default CurrencyToggle
